import Modal from "../../../components/common/Modal";
import { formatCurrency, formatDateTime } from "../../../utils/formatters";
import { Building2, CreditCard, User, Calendar } from "lucide-react";

const InfoRow = ({ label, value, highlight }) => (
  <div className="flex justify-between items-center py-2 border-b border-border last:border-0">
    <span className="text-xs text-text-muted">{label}</span>
    <span
      className={`text-sm font-medium ${highlight ? "text-primary" : "text-text-primary"}`}
    >
      {value}
    </span>
  </div>
);

const PayoutApproveModal = ({
  payout,
  onClose,
  onConfirm,
  approving,
  error,
}) => (
  <Modal isOpen={!!payout} onClose={onClose} title="Approve Payout">
    <div className="space-y-5">
      {/* Hub info */}
      <div className="flex items-center gap-3 p-3 bg-bg-base rounded-xl border border-border">
        {payout?.hubImage ? (
          <img
            src={payout.hubImage}
            alt=""
            className="w-10 h-10 rounded-lg object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-lg bg-bg-elevated flex items-center justify-center">
            <Building2 size={16} className="text-text-muted" />
          </div>
        )}
        <div>
          <p className="text-sm font-semibold text-text-primary">
            {payout?.hubName}
          </p>
          <p className="text-xs text-text-muted">{payout?.eventTitle}</p>
        </div>
      </div>

      {/* Financial breakdown */}
      <div className="bg-bg-base rounded-xl border border-border p-4 space-y-1">
        <p className="text-xs text-text-muted uppercase tracking-wide mb-3">
          Financial Breakdown
        </p>
        <InfoRow
          label="Gross Amount"
          value={formatCurrency(payout?.grossAmount)}
        />
        <InfoRow
          label="Ingroove Fee"
          value={formatCurrency(payout?.ingrooveCommission)}
        />
        <InfoRow
          label="Hub Payout"
          value={formatCurrency(payout?.hubCommission)}
          highlight
        />
      </div>

      {/* Banking details */}
      <div className="bg-bg-base rounded-xl border border-border p-4 space-y-1">
        <p className="text-xs text-text-muted uppercase tracking-wide mb-3">
          Banking Details
        </p>
        <InfoRow
          label={
            <span className="flex items-center gap-1">
              <Building2 size={11} /> Bank
            </span>
          }
          value={payout?.bankName || "—"}
        />
        <InfoRow
          label={
            <span className="flex items-center gap-1">
              <CreditCard size={11} /> Account
            </span>
          }
          value={payout?.accountNumber || "—"}
        />
        <InfoRow
          label={
            <span className="flex items-center gap-1">
              <User size={11} /> Owner
            </span>
          }
          value={payout?.ownerName}
        />
        <InfoRow
          label={
            <span className="flex items-center gap-1">
              <Calendar size={11} /> Requested
            </span>
          }
          value={payout?.requestedAt ? formatDateTime(payout.requestedAt) : "—"}
        />
      </div>

      {error && (
        <p className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
          {error}
        </p>
      )}

      {/* Actions */}
      <div className="flex gap-3">
        <button
          onClick={onClose}
          className="flex-1 py-2 rounded-lg text-sm border border-border text-text-muted hover:border-border-hover transition"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={approving}
          className="flex-1 py-2 rounded-lg text-sm omnyx-gradient-bg text-white font-semibold hover:opacity-90 transition disabled:opacity-50"
        >
          {approving
            ? "Processing..."
            : `Approve ${formatCurrency(payout?.hubCommission)}`}
        </button>
      </div>
    </div>
  </Modal>
);

export default PayoutApproveModal;
